import React from "react"
import Icons from "./Icons"
export default function Footer(){
    return(
        <div className="footer">
            <ul>
                <Icons />
            </ul>
        </div>
    )
}